<template>
  <v-layout d-flex wrap align-center class="ml-3 justify-space-between">
    <v-flex xs12 sm6 md2 d-flex class="pa-1">
      <v-select label="Tipo/Item" placeholder="Todos" multiple ref="selectLoteFiltros"
                v-model="filtros.lotes" item-text="descricao" item-value="id" :menu-props="{ top: false, offsetY: true }"
                :items="lotesDisponiveis" no-data-text="Nenhum Tipo/Item disponível">
        <template v-if="item" slot="selection" slot-scope="{item, index}">
          <v-chip v-if="index === 0" small>
            <span>{{ item.descricao }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text" style="font-size: 0.8em">
           +{{ filtros.lotes.length - 1 }} outros
          </span>
        </template>
        <span slot="prepend-item">
          <v-list-tile ripple @click="filtros.lotes = null; $refs.selectLoteFiltros.blur()">
            <v-list-tile-title>
              Todos
            </v-list-tile-title>
          </v-list-tile>
        </span>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md3 d-flex class="pa-1">
      <v-select label="Fornecedor" placeholder="Todos" item-text="razaoSocial" item-value="id"
                v-model="filtros.fornecedorId" ref="selectFornecedorFiltros"
                no-data-text="Nenhum fornecedor disponível" :menu-props="{ top: false, offsetY: true }"
                :items="fornecedoresDisponiveis">
        <span slot="prepend-item">
          <v-list-tile ripple @click="filtros.fornecedorId = null; $refs.selectFornecedorFiltros.blur()">
            <v-list-tile-title>
              Todos
            </v-list-tile-title>
          </v-list-tile>
        </span>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md2 d-flex class="pa-1">
      <v-select label="Tipo" placeholder="Todos" ref="selectTipoDocumentoFiltros"
                v-model="filtros.tipoDocumento" item-text="texto" item-value="valor"
                :menu-props="{ top: false, offsetY: true }"
                :items="converterEnumParaSelect(tiposDocumentoVirtualizados)">
        <span slot="prepend-item">
          <v-list-tile ripple @click="filtros.tipoDocumento = null; $refs.selectTipoDocumentoFiltros.blur()">
            <v-list-tile-title>
              Todos
            </v-list-tile-title>
          </v-list-tile>
        </span>
      </v-select>
    </v-flex>
    <v-flex xs12 sm6 md2 d-flex class="pa-1">
      <v-select label="Situação" placeholder="Todas" ref="selectsituacaoFiltros"
                v-model="filtros.situacao" item-text="texto" item-value="valor"
                :menu-props="{ top: false, offsetY: true }"
                :items="converterEnumParaSelect(situacoesDocumentosVirtualizados)">
        <span slot="prepend-item">
          <v-list-tile ripple @click="filtros.situacao = null; $refs.selectsituacaoFiltros.blur()">
            <v-list-tile-title>
              Todas
            </v-list-tile-title>
          </v-list-tile>
        </span>
      </v-select>
    </v-flex>
    <v-flex xs12 sm12 md3 class="d-flex flex-row">
      <az-call-to-action dark
                         :active="true"
                         :outline="false"
                         @click="aplicarFiltros">
        Pesquisar
      </az-call-to-action>
      <az-call-to-action :active="false"
                         :outline="true"
                         @click="limparFiltros">
        Limpar
      </az-call-to-action>
    </v-flex>
  </v-layout>
</template>
<script>
import {situacoesDocumentosVirtualizados, tiposDocumentoVirtualizados} from '@/commons/constants'
import AzComboEnumLicitacao from "@/commons/components/AzComboEnumLicitacao";

export default {
  name: 'filtrosDocumentos',
  components: {AzComboEnumLicitacao},
  props: ['lotesDisponiveis','fornecedoresDisponiveis'],
  data(){
    return{
      situacoesDocumentosVirtualizados,
      tiposDocumentoVirtualizados,
      filtros:{
        lotes: null,
        fornecedorId: null,
        tipoDocumento: null,
        situacao: null
      },
    }
  },
  methods:{
    aplicarFiltros(){
      this.$emit('pesquisar', this.filtros)
    },
    limparFiltros(){
      this.filtros = {lotes: null, fornecedorId: null, tipoDocumento: null, situacao: null}
      this.aplicarFiltros();
    },
    converterEnumParaSelect(opcoes){
      return Object.entries(opcoes).map((e) => (
          {valor: e[0], texto: e[1]}
      ))
    },
  },
}
</script>